import { apiClient } from './api'

export interface SearchResultItem {
  id: string
  type: 'device' | 'account' | 'user' | 'alert' | 'document'
  title: string
  description: string
  url: string
  metadata?: Record<string, string>
}

export interface SearchResponse {
  results: SearchResultItem[]
  total: number
}

export const searchService = {
  search: async (query: string, limit: number = 50): Promise<SearchResponse> => {
    const { data } = await apiClient.get<SearchResponse>('/search', {
      params: { q: query, limit }
    })
    return data
  }
}
